import { render, staticRenderFns } from "./ToolbarNotificationsMenu.vue?vue&type=template&id=c3dc0144"
import script from "./ToolbarNotificationsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarNotificationsMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports